const webhook = {
  latest_20_events: "Últimos 20 eventos",
  refresh: "Actualizar",
  access_denied: "Acceso denegado",
  no_data_found: "No se encontraron datos",
  event_id: "ID del evento",
  event_type: "Tipo de evento",
  status: "Estado",
  retry_count: "Número de reintentos",
  date: "Fecha",
  destination_url: "URL de destino",
  create_date: "Fecha de creación",
  message: "Mensaje",
  event_logs: "Registros del evento",
  attempts: "{{count}} intentos",
  select_an_event_to_view_details: "Selecciona un evento para ver los detalles",
  time: "Hora",
  payload: "Contenido",
  copy: "Copiar",
  copied: "Copiado",
  Pending: "Pendiente",
  Failed: "Fallido",
  Sent: "Enviado",
  DocumentApproval: `Aprobación de documento`,
  DocumentApproved: `Documento aprobado`,
  DocumentRejected: `Documento rechazado`,
  DocumentCreated: `Documento creado`,
  DocumentDeleted: `Documento eliminado`,
  DocumentProcessed: `Documento procesado`,
  DocumentReviewed: `Documento revisado`,
};

export default webhook;
